import { render } from "./upsellModal.vue?vue&type=template&id=608707a0&scoped=true&ts=true"
import script from "./upsellModal.vue?vue&type=script&lang=ts"
export * from "./upsellModal.vue?vue&type=script&lang=ts"

import "./upsellModal.vue?vue&type=style&index=0&id=608707a0&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608707a0"]])

export default __exports__